import { render, staticRenderFns } from "./AppointmentIntegration.vue?vue&type=template&id=2c3d50b8&"
import script from "./AppointmentIntegration.vue?vue&type=script&lang=ts&"
export * from "./AppointmentIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports